// Mock data for Lyft clone

export const rideTypes = [
  {
    id: 'standard',
    name: 'Tekstar',
    description: 'Affordable, everyday rides',
    capacity: 4,
    icon: '🚗',
    priceMultiplier: 1,
    eta: '2-5 min',
  },
  {
    id: 'xl',
    name: 'Tekstar XL',
    description: 'Affordable rides for groups up to 6',
    capacity: 6,
    icon: '🚙',
    priceMultiplier: 1.5,
    eta: '3-7 min',
  },
  {
    id: 'lux',
    name: 'Lux',
    description: 'Premium rides in luxury vehicles',
    capacity: 4,
    icon: '🚘',
    priceMultiplier: 2.2,
    eta: '5-10 min',
  },
  {
    id: 'shared',
    name: 'Shared',
    description: 'Share the ride, split the cost',
    capacity: 2,
    icon: '👥',
    priceMultiplier: 0.7,
    eta: '3-8 min',
  },
];

export const mockDrivers = [
  {
    id: '1',
    name: 'Sarah Johnson',
    rating: 4.9,
    rides: 2341,
    car: 'Toyota Camry',
    plate: 'ABC 1234',
    photo: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah',
  },
  {
    id: '2',
    name: 'Mike Chen',
    rating: 4.95,
    rides: 3102,
    car: 'Honda Accord',
    plate: 'XYZ 5678',
    photo: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mike',
  },
  {
    id: '3',
    name: 'Emma Davis',
    rating: 4.88,
    rides: 1876,
    car: 'Nissan Altima',
    plate: 'DEF 9012',
    photo: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emma',
  },
];

export const mockRides = [
  {
    id: '1',
    date: '2025-01-15T14:30:00',
    pickup: 'Kasama Town Centre, Kasama, Zambia',
    dropoff: 'Kasama Central Market, Kasama, Zambia',
    driver: mockDrivers[0],
    rideType: rideTypes[0],
    price: 12.50,
    status: 'completed',
  },
  {
    id: '2',
    date: '2025-01-14T09:15:00',
    pickup: 'Kasama Bus Station, Kasama, Zambia',
    dropoff: 'Freedom Avenue, Kasama, Zambia',
    driver: mockDrivers[1],
    rideType: rideTypes[1],
    price: 18.75,
    status: 'completed',
  },
  {
    id: '3',
    date: '2025-01-13T18:45:00',
    pickup: 'Mungwi Road, Kasama, Zambia',
    dropoff: 'Kasama General Hospital, Kasama, Zambia',
    driver: mockDrivers[2],
    rideType: rideTypes[2],
    price: 28.90,
    status: 'completed',
  },
];

export const calculatePrice = (distance, rideTypeId) => {
  const basePrice = 3.50;
  const perMile = 1.80;
  const rideType = rideTypes.find(rt => rt.id === rideTypeId);
  const multiplier = rideType?.priceMultiplier || 1;
  
  return ((basePrice + (distance * perMile)) * multiplier).toFixed(2);
};

export const mockLocations = [
  'Kasama Town Centre, Kasama, Zambia',
  'Freedom Avenue, Kasama, Zambia',
  'Mungwi Road, Kasama, Zambia',
  'Kasama Central Market, Kasama, Zambia',
  'Kasama Bus Station, Kasama, Zambia',
  'Kasama General Hospital, Kasama, Zambia',
  'Chisanga Road, Kasama, Zambia',
  'Zambia Way, Kasama, Zambia',
  'Mbesuma Road, Kasama, Zambia',
  'Chambeshi Road, Kasama, Zambia',
  'Lukupa Road, Kasama, Zambia',
  'Kasama Airport, Kasama, Zambia',
  'Kasama Secondary School, Kasama, Zambia',
  'St. Mary\'s Cathedral, Kasama, Zambia',
  'Kasama Police Station, Kasama, Zambia',
  'Northern Province Government Complex, Kasama, Zambia',
  'Kasama Golf Club, Kasama, Zambia',
  'Shoprite Kasama, Kasama, Zambia',
  'Kasama Technical College, Kasama, Zambia',
  'Chitimukulu Road, Kasama, Zambia',
];